import firebase from '../firebase'
const db = firebase.firestore()
const collectionInspirados = db.collection('inspirados')

const guardarNuevoInspirado = async (inspirado, idInspirador) => {
  // Validación si un inspirado ya existe por documento de identidad
  const exists = await db.collection('inspirados')
    .where('numeroIdentificacion', '==', inspirado.numeroIdentificacion)
    .get()
  if (exists && exists.docs[0]) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line prefer-promise-reject-errors
      return reject('El inspirado ya está registrado')
    })
  }

  inspirado.correo = inspirado.correo.toLowerCase()
  inspirado.createdAt = Date.now()
  inspirado.idInspirador = db.doc(`usuarios/${idInspirador}`)

  const inspirador = await db.doc(`usuarios/${idInspirador}`).get()
  await inspirado.idInspirador.update({ numInspirados: (inspirador.data().numInspirados || 0) + 1 })

  return collectionInspirados.add(inspirado)
}

const eliminarInspirado = async (inspirado) => {
  const inspiradoDoc = await obtenerInspiradoPorId(inspirado)
  const inspirador = await inspiradoDoc.data().idInspirador.get()
  console.log(inspirador.data())
  debugger
  await inspiradoDoc.data().idInspirador.update({ numInspirados: (inspirador.data().numInspirados || 0) - 1 })

  return collectionInspirados.doc(inspirado).delete()
}

const actualizarInspirado = (inspirado, idInspirado) => {
  return collectionInspirados.doc(idInspirado).update(inspirado)
}

const obtenerInspiradosPorId = (refInspirador) => {
  return collectionInspirados.where('idInspirador', '==', refInspirador).get()
}

const obtenerInspiradoPorId = (inspiradosId) => {
  return collectionInspirados
    .doc(inspiradosId)
    .get()
}

export default {
  obtenerInspiradosPorId,
  obtenerInspiradoPorId,
  guardarNuevoInspirado,
  actualizarInspirado,
  eliminarInspirado
}
